module.exports = __webpack_public_path__ + "flyer_image_overlay_shifting_geometric_shapes_005-9d2a0863d97ba3f01064c1d01cca84ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_shifting_geometric_shapes_005.png
// module id = 1571
// module chunks = 1